import { useMemo, useState } from "react";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import { useNavigate } from "react-router";
import { useSearchFilter } from "../../../../../utils/functions/useDate";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageStyle from "../../../Components/Layout/PageLayout";
import { TableActions } from "../../../Components/Misc/Actions";
import Pagination from "../../../Components/Pagination/Pagination";
import {
  CalendarFilter2,
  ProDropFilter,
  SearchFilter,
} from "../../../Components/Search/Search";
import Table from "../../../Components/Table/Table";
import { useGetAllPIPEmployeeQuery } from "../../../../api/employeeApi";
import { GetLocalStorage } from "../../../../../utils/functions/GetLocalStorage";
import { getStatusText } from "../../Finance/CostCenter/Class";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
import { FilterByStatus } from "../../HR/Appraisal/status";

const EmployeePIP = () => {
  const {
    searchText,
    filter,
    setSearchText,
    setFilter,
    date,
    setDate,
    // findSearch,
    pageSize,
    setPageSize,
    currentPage,
    setCurrentPage,
  } = useSearchFilter({
    initialFilter: 1,
  });
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("asc");
  const user = GetLocalStorage();
  const { data, isLoading } = useGetAllPIPEmployeeQuery({
    PageNumber: currentPage,
    PageSize: pageSize,
    StartDate: startDate,
    EndDate: endDate,
    GeneralSearch: searchText,
    AppraiseeId: user.staffId,
    ApprovalStatus: filter,
  });

  const navigate = useNavigate();

  const handleView = (id, referenceId) => {
    if (id) {
      navigate(`${id}/view/${referenceId}`);
    }
  };

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortDirection("asc");
    }
  };

  const sortedData = useMemo(() => {
    if (!data?.result) return [];
    return [...data.result].sort((a, b) => {
      if (!sortColumn) return 0;
      let aValue = a[sortColumn];
      let bValue = b[sortColumn];

      // For strings, make case-insensitive
      if (typeof aValue === "string") {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }

      if (aValue < bValue) return sortDirection === "asc" ? -1 : 1;
      if (aValue > bValue) return sortDirection === "asc" ? 1 : -1;
      return 0;
    });
  }, [data?.result, sortColumn, sortDirection]);

  const renderSortIcon = (column) => {
    if (sortColumn !== column) return <FaSort className="ml-1" />;
    return sortDirection === "asc" ? (
      <FaSortUp className="ml-1" />
    ) : (
      <FaSortDown className="ml-1" />
    );
  };

  return (
    <PageStyle
      hasBack={false}
      demoTitle={"PERFORMANCE IMPROVEMENT PLAN"}
      hasTopPageDemo
    >
      <form className={DashboardStyle.dashboard_filter}>
        <SearchFilter
          value={searchText}
          text={(searchText) => setSearchText(searchText)}
        />
        <CalendarFilter2
          name="Select Date Range"
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          normalDate
        />
        <ProDropFilter
          filter={filter}
          setFilter={setFilter}
          name={"Status"}
          filterBy={FilterByStatus}
        />
      </form>
      <div className={DashboardStyle.dashboard_table_holder}>
        <Table>
          <thead>
            <tr>
              <th>S/N</th>
              <th
                onClick={() => handleSort("pipObjective")}
                style={{ cursor: "pointer" }}
              >
                PIP Objective {renderSortIcon("pipObjective")}
              </th>
              <th
                onClick={() => handleSort("expectedImprovement")}
                style={{ cursor: "pointer" }}
              >
                Expected Improvement {renderSortIcon("expectedImprovement")}
              </th>
              {/* <th
                onClick={() => handleSort("developmentPlan")}
                style={{ cursor: "pointer" }}
              >
                Development Plan {renderSortIcon("developmentPlan")}
              </th> */}
              {/* <th
                onClick={() => handleSort("targetImprovementPercent")}
                style={{ cursor: "pointer" }}
              >
                Target Improvement Percent{" "}
                {renderSortIcon("targetImprovementPercent")}
              </th> */}
              <th
                onClick={() => handleSort("engagementHours")}
                style={{ cursor: "pointer" }}
              >
                Engagement Hours {renderSortIcon("engagementHours")}
              </th>
              {/* <th>Initiated Date</th> */}
              <th
                onClick={() => handleSort("startDate")}
                style={{ cursor: "pointer" }}
              >
                Start Date {renderSortIcon("startDate")}
              </th>
              <th
                onClick={() => handleSort("endDate")}
                style={{ cursor: "pointer" }}
              >
                End Date {renderSortIcon("endDate")}
              </th>
              <th
                onClick={() => handleSort("approvalStatus")}
                style={{ cursor: "pointer" }}
              >
                Approval Status {renderSortIcon("approvalStatus")}
              </th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {isLoading && (
              <tr>
                <td colSpan={10} className="text-center">
                  Loading...
                </td>
              </tr>
            )}
            {sortedData?.length > 0 &&
              sortedData?.map((items, index) => (
                <tr key={items.id || index}>
                  <td>{index + 1}</td>
                  <td>{items?.pipObjective}</td>
                  <td>{items?.expectedImprovement}</td>
                  {/* <td>{items?.developmentPlan}</td>
                  <td>{items?.targetImprovementPercent}</td> */}
                  <td>{items?.engagementHours}</td>
                  {/* <td>{items?.appraiseeComment}</td> */}
                  <td>{FormatDateTime(items?.startDate, "DD/MM/YYYY")}</td>
                  <td>{FormatDateTime(items?.endDate, "DD/MM/YYYY")}</td>
                  <td>
                    {typeof items?.approvalStatus === "number"
                      ? getStatusText(items?.approvalStatus)
                      : items?.approvalStatus}
                  </td>
                  <td>
                    <TableActions
                      hasChildren={true}
                      url={`${items.id}/view/${items.referenceId}`}
                    >
                      {[
                        {
                          name: "View Details",
                          action: () => handleView(items.id, items.referenceId),
                        },
                      ]}
                    </TableActions>
                  </td>
                </tr>
              ))}
            {sortedData?.length === 0 && !isLoading && (
              <tr>
                <td colSpan={10} className="text-center">
                  No items Records Found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <Pagination
        last_page={data?.responseObject?.previousPage}
        present_page={data?.responseObject?.currentPage}
        totalRows={data?.responseObject?.totalCount}
        pageSize={data?.responseObject?.pageSize}
        setPageSize={(page) => setPageSize(page)}
        click={(page) => setCurrentPage(page)}
      />
    </PageStyle>
  );
};

export default EmployeePIP;
